import SideMenu from './SideMenu';

export { SideMenu };
export default SideMenu;
